"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texVariant = {
    0x20: [0, 0, .25],
    0x41: [.701, 0, .722],
    0x42: [.683, 0, .667],
    0x43: [.702, .019, .722],
    0x44: [.683, 0, .722],
    0x45: [.683, 0, .667],
    0x46: [.683, 0, .611],
    0x47: [.702, .019, .778],
    0x48: [.683, 0, .778],
    0x49: [.683, 0, .389],
    0x4A: [.683, .077, .5],
    0x4B: [.683, 0, .778],
    0x4C: [.683, 0, .667],
    0x4D: [.683, 0, .944],
    0x4E: [.683, .02, .722],
    0x4F: [.701, .019, .778],
    0x50: [.683, 0, .611],
    0x51: [.701, .181, .778],
    0x52: [.683, 0, .722],
    0x53: [.702, .012, .556],
    0x54: [.683, 0, .667],
    0x55: [.683, .019, .722],
    0x56: [.683, .02, .722],
    0x57: [.683, .019, 1],
    0x58: [.683, 0, .722],
    0x59: [.683, 0, .722],
    0x5A: [.683, 0, .667],
    0x6B: [.683, 0, .556],
    0xA0: [0, 0, .25],
    0xA5: [.683, 0, .75],
    0xAE: [.709, .175, .947],
    0xF0: [.749, .021, .556],
    0x127: [.695, .013, .54, { ic: .022 }],
    0x2C6: [.845, -0.561, 2.333, { ic: .013 }],
    0x2DC: [.899, -0.628, 2.333],
    0x302: [.845, -0.561, 0, { ic: .013 }],
    0x303: [.899, -0.628, 0],
    0x3DC: [.605, .085, .778],
    0x3DD: [.605, .085, .778],
    0x3F0: [.434, .006, .667, { ic: .067 }],
    0x2035: [.56, -0.043, .275],
    0x210F: [.695, .013, .54, { ic: .022 }],
    0x2127: [.684, .022, .722],
    0x2132: [.695, 0, .556],
    0x2136: [.763, .021, .667, { ic: .02 }],
    0x2137: [.764, .043, .444],
    0x2138: [.764, .043, .667],
    0x2141: [.705, .023, .639],
    0x2190: [.437, -0.064, .5],
    0x2192: [.437, -0.064, .5],
    0x219A: [.437, -0.06, 1],
    0x219B: [.437, -0.06, 1],
    0x219E: [.417, -0.083, 1],
    0x21A0: [.417, -0.083, 1],
    0x21A2: [.417, -0.083, 1.111],
    0x21A3: [.417, -0.083, 1.111],
    0x21AB: [.575, .041, 1],
    0x21AC: [.575, .041, 1],
    0x21AD: [.417, -0.083, 1.389],
    0x21AE: [.437, -0.06, 1],
    0x21B0: [.722, 0, .5],
    0x21B1: [.722, 0, .5],
    0x21B6: [.461, 0, 1],
    0x21B7: [.46, 0, 1],
    0x21BA: [.65, .083, .778],
    0x21BB: [.65, .083, .778],
    0x21BE: [.694, .194, .417],
    0x21BF: [.694, .194, .417],
    0x21C2: [.694, .194, .417],
    0x21C3: [.694, .194, .417],
    0x21C4: [.667, 0, 1],
    0x21C6: [.667, 0, 1],
    0x21C7: [.583, .083, 1],
    0x21C8: [.694, .193, .833],
    0x21C9: [.583, .083, 1],
    0x21CA: [.694, .194, .833],
    0x21CB: [.514, .014, 1],
    0x21CC: [.514, .014, 1],
    0x21CD: [.534, .035, 1],
    0x21CE: [.534, .037, 1],
    0x21CF: [.534, .035, 1],
    0x21DA: [.611, .111, 1],
    0x21DB: [.611, .111, 1],
    0x21DD: [.417, -0.083, 1],
    0x21E0: [.437, -0.064, 1.334],
    0x21E2: [.437, -0.064, 1.334],
    0x2201: [.846, .021, .5],
    0x2204: [.86, .166, .556],
    0x2205: [.587, 0, .778],
    0x220D: [.44, 0, .429, { ic: .027 }],
    0x2212: [.27, -0.23, .5],
    0x2214: [.766, .093, .778],
    0x2216: [.43, .023, .778],
    0x221D: [.472, -0.028, .778],
    0x2220: [.694, 0, .722],
    0x2221: [.714, .02, .722],
    0x2222: [.551, .051, .722],
    0x2223: [.43, .023, .222],
    0x2224: [.43, .023, .222, { ic: .018 }],
    0x2225: [.431, .023, .389],
    0x2226: [.431, .024, .389, { ic: .018 }],
    0x2234: [.471, .082, .667],
    0x2235: [.471, .082, .667],
    0x223C: [.365, -0.132, .778],
    0x223D: [.367, -0.133, .778],
    0x2241: [.467, -0.032, .778],
    0x2242: [.463, -0.034, .778],
    0x2246: [.652, .155, .778],
    0x2248: [.481, -0.05, .778],
    0x224A: [.579, .039, .778],
    0x224E: [.492, -0.008, .778],
    0x224F: [.492, -0.133, .778],
    0x2251: [.609, .108, .778],
    0x2252: [.601, .101, .778],
    0x2253: [.601, .102, .778],
    0x2256: [.367, -0.133, .778],
    0x2257: [.721, -0.133, .778],
    0x225C: [.859, -0.133, .778],
    0x2266: [.753, .175, .778],
    0x2267: [.753, .175, .778],
    0x2268: [.752, .284, .778],
    0x2269: [.752, .284, .778],
    0x226C: [.75, .25, .5],
    0x226E: [.708, .209, .778],
    0x226F: [.708, .209, .778],
    0x2270: [.919, .421, .778],
    0x2271: [.919, .421, .778],
    0x2272: [.732, .228, .778],
    0x2273: [.732, .228, .778],
    0x2276: [.681, .253, .778],
    0x2277: [.681, .253, .778],
    0x227C: [.58, .153, .778],
    0x227D: [.58, .154, .778],
    0x227E: [.732, .228, .778],
    0x227F: [.732, .228, .778],
    0x2280: [.705, .208, .778],
    0x2281: [.705, .208, .778],
    0x2288: [.828, .33, .778],
    0x2289: [.828, .33, .778],
    0x228A: [.634, .255, .778],
    0x228B: [.634, .254, .778],
    0x228F: [.539, .041, .778],
    0x2290: [.539, .041, .778],
    0x229A: [.582, .082, .778],
    0x229B: [.582, .082, .778],
    0x229D: [.582, .082, .778],
    0x229E: [.689, 0, .778],
    0x229F: [.689, 0, .778],
    0x22A0: [.689, 0, .778],
    0x22A1: [.689, 0, .778],
    0x22A8: [.694, 0, .611],
    0x22A9: [.694, 0, .722],
    0x22AA: [.694, 0, .889],
    0x22AC: [.695, 0, .611],
    0x22AD: [.695, 0, .611],
    0x22AE: [.695, 0, .722],
    0x22AF: [.695, 0, .722],
    0x22B2: [.539, .041, .778],
    0x22B3: [.539, .041, .778],
    0x22B4: [.636, .138, .778],
    0x22B5: [.636, .138, .778],
    0x22B8: [.408, -0.092, 1.111],
    0x22BA: [.431, .212, .556],
    0x22BB: [.716, 0, .611],
    0x22BC: [.716, 0, .611],
    0x22C5: [.189, 0, .278],
    0x22C7: [.545, .044, .778],
    0x22C9: [.492, -0.008, .778],
    0x22CA: [.492, -0.008, .778],
    0x22CB: [.694, .022, .778],
    0x22CC: [.694, .022, .778],
    0x22CD: [.464, -0.036, .778],
    0x22CE: [.578, .021, .76],
    0x22CF: [.578, .022, .76],
    0x22D0: [.54, .04, .778],
    0x22D1: [.54, .04, .778],
    0x22D2: [.598, .022, .667],
    0x22D3: [.598, .022, .667],
    0x22D4: [.736, .022, .667],
    0x22D6: [.541, .041, .778],
    0x22D7: [.541, .041, .778],
    0x22D8: [.568, .067, 1.333],
    0x22D9: [.568, .067, 1.333],
    0x22DA: [.886, .386, .778],
    0x22DB: [.886, .386, .778],
    0x22DE: [.734, 0, .778],
    0x22DF: [.734, 0, .778],
    0x22E0: [.801, .303, .778],
    0x22E1: [.801, .303, .778],
    0x22E6: [.73, .359, .778],
    0x22E7: [.73, .359, .778],
    0x22E8: [.73, .359, .778],
    0x22E9: [.73, .359, .778],
    0x22EA: [.706, .208, .778],
    0x22EB: [.706, .208, .778],
    0x22EC: [.802, .303, .778],
    0x22ED: [.801, .303, .778],
    0x2322: [.378, -0.122, .778],
    0x2323: [.378, -0.143, .778],
    0x24C8: [.709, .175, .902],
    0x250C: [.694, -0.306, .5],
    0x2510: [.694, -0.306, .5],
    0x2514: [.366, .022, .5],
    0x2518: [.366, .022, .5],
    0x2571: [.694, .195, .889],
    0x2572: [.694, .195, .889],
    0x25A0: [.689, 0, .778],
    0x25A1: [.689, 0, .778],
    0x25B2: [.575, .02, .722],
    0x25B3: [.575, .02, .722],
    0x25B6: [.539, .041, .778],
    0x25BC: [.576, .019, .722],
    0x25BD: [.576, .019, .722],
    0x25C0: [.539, .041, .778],
    0x25CA: [.716, .132, .667],
    0x2605: [.694, .111, .944],
    0x2713: [.706, .034, .833],
    0x2720: [.716, .022, .833],
    0x29EB: [.716, .132, .667],
    0x2A5E: [.813, .097, .611],
    0x2A7D: [.636, .138, .778],
    0x2A7E: [.636, .138, .778],
    0x2A85: [.762, .29, .778],
    0x2A86: [.762, .29, .778],
    0x2A87: [.801, .303, .778],
    0x2A88: [.801, .303, .778],
    0x2A89: [.761, .387, .778],
    0x2A8A: [.761, .387, .778],
    0x2A8B: [1.003, .463, .778],
    0x2A8C: [1.003, .463, .778],
    0x2A95: [.636, .138, .778],
    0x2A96: [.636, .138, .778],
    0x2AB5: [.752, .286, .778],
    0x2AB6: [.752, .286, .778],
    0x2AB7: [.761, .294, .778],
    0x2AB8: [.761, .294, .778],
    0x2AB9: [.761, .337, .778],
    0x2ABA: [.761, .337, .778],
    0x2AC5: [.753, .215, .778],
    0x2AC6: [.753, .215, .778],
    0x2ACB: [.752, .332, .778],
    0x2ACC: [.752, .333, .778],
    0xE006: [.43, .023, .222, { ic: .018 }],
    0xE007: [.431, .024, .389, { ic: .018 }],
    0xE008: [.605, .085, .778],
    0xE009: [.434, .006, .667, { ic: .067 }],
    0xE00C: [.752, .284, .778],
    0xE00D: [.752, .284, .778],
    0xE00E: [.919, .421, .778],
    0xE00F: [.801, .303, .778],
    0xE010: [.801, .303, .778],
    0xE011: [.919, .421, .778],
    0xE016: [.828, .33, .778],
    0xE017: [.752, .332, .778],
    0xE018: [.828, .33, .778],
    0xE019: [.752, .333, .778],
    0xE01A: [.634, .255, .778],
    0xE01B: [.634, .254, .778],
};
//# sourceMappingURL=tex-variant.js.map